import React, { useId } from 'react';
import ModernTimeDropdown from '../../dashboard-components/layouts/modernDropdown';

export const inputClass = 'w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 disabled:bg-gray-50';
export const secondaryButton = 'inline-flex items-center gap-2 px-3 py-2 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed';
export const primaryButton = 'inline-flex items-center gap-2 px-4 py-2 text-sm bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed';

export function Field({ label, error, hint, children }) {
  const id = useId();
  return <div className="min-w-0">
    <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
    {React.cloneElement(children, { id, 'aria-invalid': Boolean(error), 'aria-describedby': error || hint ? `${id}-help` : undefined })}
    {(error || hint) && <p id={`${id}-help`} className={`mt-1 text-xs ${error ? 'text-red-700' : 'text-gray-500'}`}>{error || hint}</p>}
  </div>;
}

export function ErrorSummary({ errors }) {
  const entries = Object.entries(errors || {});
  if (!entries.length) return null;
  return <div role="alert" className="rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-800">
    <p className="font-medium">Please correct the configuration:</p>
    <ul className="list-disc pl-5 mt-1">{entries.map(([key, message]) => <li key={key}>{message}</li>)}</ul>
  </div>;
}

export function ModeCheckboxes({ value, onChange, available = ['voice', 'chat'], label = 'Applicable modes', keepOne = false }) {
  return <fieldset className="flex gap-4 items-center text-sm">
    <legend className="text-sm font-medium text-gray-700 mb-2">{label}</legend>
    {available.map(mode => <label key={mode} className="inline-flex items-center gap-2">
      <input type="checkbox" checked={value.includes(mode)} disabled={keepOne && value.length === 1 && value.includes(mode)} onChange={e => onChange(e.target.checked ? [...value, mode] : value.filter(item => item !== mode))} />
      {mode === 'voice' ? 'Voice' : 'Chat'}
    </label>)}
  </fieldset>;
}

// Keep the dashboard dropdown while mapping display labels to stored values.
export function StandardSelect({ value, options = [], onChange, placeholder = 'Select', disabled = false, id }) {
  const choices = options.map(option => typeof option === 'string' ? { value: option, label: option } : option);
  const selected = choices.find(option => option.value === value);
  return <ModernTimeDropdown id={id} value={selected?.label || value || ''} placeholder={placeholder}
    options={choices.filter(option => !option.disabled).map(option => option.label)} width="w-full" isDisabled={disabled}
    onChange={event => {
      const option = choices.find(item => item.label === event.target.value);
      if (option && !option.disabled) onChange({ target: { value: option.value } });
    }} />;
}
